import React from 'react';
import { Menu, MenuItem, Box, Typography, Select } from '@mui/material';
import { usePrincipal } from '../../principal/PrincipalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useKrTheme } from '@/common/theme/KrThemeContext';
import { useEntityChange } from '@/common/entityChange/EntityChangeContext';

export const ProfileMenu = ({ anchorEl, open, onClose }) => {
  const { principal, org, logout, changeOrg } = usePrincipal() ;
  const { isDarkMode, toggleDarkMode } = useKrTheme();
  const { blockRefreshTrigger, toggleBlockRefreshTrigger } = useEntityChange();

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      slotProps={{ paper: { sx: { width: 280 } } }}
    >
      <Box onClick={(e) => e.stopPropagation()} sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Box
            component="img"
            src={principal.picture}
            alt="Profile"
            sx={{ width: 40, height: 40, borderRadius: '50%', mr: 2 }}
          />
          <Box>
            <Typography variant="subtitle1">{principal.name}</Typography>
            <Typography variant="body2" color="text.secondary">{principal.username}</Typography>
          </Box>
        </Box>
        <Box>
          {principal.orgs && principal.orgs.length > 0 && (
            <MenuItem
              disableRipple
              sx={{ borderRadius: (theme) => theme.shape.borderRadius }}
            >
              <FontAwesomeIcon
                icon={fas.faGlobe}
                style={{ marginRight: 8 }}
              />
              <Select
                value={org}
                onChange={(e) => changeOrg(e.target.value)}
                variant="standard"
                disableUnderline
                sx={{
                  padding: 0,
                  minWidth: 0,
                }}
              >
                {principal.orgs.map((org) => (
                  <MenuItem key={org} value={org}>
                    {org}
                  </MenuItem>
                ))}
              </Select>
            </MenuItem>
          )}
        </Box>

        <MenuItem
          onClick={toggleDarkMode}
          sx={{ borderRadius: (theme) => theme.shape.borderRadius }}
        >
          <FontAwesomeIcon
            icon={isDarkMode ? fas.faSun : fas.faMoon}
            style={{ marginRight: 8 }}
          />
          {isDarkMode ? 'Light Mode' : 'Dark Mode'}
        </MenuItem>
        <MenuItem onClick={toggleBlockRefreshTrigger} sx={{ borderRadius: theme => theme.shape.borderRadius }}>
          <FontAwesomeIcon
            icon={blockRefreshTrigger ? fas.faRotate : fas.faBan}
            style={{ marginRight: 8 }}
          />
          {blockRefreshTrigger ? 'Enable Auto Refresh' : 'Disable Auto Refresh'}
        </MenuItem>
        <MenuItem data-test-id="logout-button" onClick={logout} sx={{ borderRadius: theme => theme.shape.borderRadius }}>
          <FontAwesomeIcon
            icon={fas.faSignOutAlt}
            style={{ marginRight: 8 }}
          />
          Logout
        </MenuItem>
      </Box>
    </Menu>
  );
};
